import { memo, useMemo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';
import { useRelevancyOptions } from '../store';
import type { RelevancyFeedOptions } from '../types';

import { trackCardElement } from '@services/GoogleTagManagerService';
import HeadToHead from '@shared/match-summary/HeadToHead';
import type { Match } from '@shared-types/match.types';
import { competitionId } from '@utilities/WindowContext';

const HeadToHeadComponent = ({ item }: RelevancyCardProps) => {
  const { options } = useRelevancyOptions();
  const cardOptions: RelevancyFeedOptions & { match: Match; extendedView: boolean } = useMemo(
    () => ({
      ...options,
      match: {
        ...item.teaser,
        competition: { id: competitionId },
        id: item.teaser.matchId,
      },
      extendedView: true,
    }),
    [item.teaser, options],
  );

  const sponsorName = useMemo(
    () => !options.disableSponsors && (item.teaser.sponsor?.type ?? item.teaser.sponsors?.at(0)),
    [options.disableSponsors, item],
  );

  const trackingData = useMemo(
    () => ({
      category: 'head to head',
      name: [
        sponsorName,
        `Head to head - ${cardOptions.match?.homeTeam?.internationalName}-${cardOptions.match?.awayTeam?.internationalName}`,
      ]
        .filter(Boolean)
        .join(' - '),
    }),
    [cardOptions.match?.awayTeam?.internationalName, cardOptions.match?.homeTeam?.internationalName, sponsorName],
  );

  return (
    <div ref={trackCardElement(trackingData)} pk-theme='light' className='card head-to-head-component'>
      <HeadToHead options={cardOptions} />
    </div>
  );
};

export default memo(HeadToHeadComponent);
